// Impor react.
import * as React from 'react';
// Import dispatch
import {
	Dispatch,
} from 'redux';
// Import dispatch hook.
import { useDispatch } from 'react-redux';

type DispatchMethodResult<TActionReturnData> = (dispatch: Dispatch) => Promise<TActionReturnData>;

type DispatchMethod<TActionReturnData, TActionParameters = void> = (params: TActionParameters) => DispatchMethodResult<TActionReturnData>;

type UseActionResult<TActionReturnData, TActionParameters = void> = (params: TActionParameters) => Promise<TActionReturnData>;

const useAction = <TActionReturnData, TActionParameters = void>(dispatchMethod: DispatchMethod<TActionReturnData, TActionParameters>): UseActionResult<TActionReturnData, TActionParameters> => {
	const dispatch: Dispatch = useDispatch();
	return React.useMemo(
		() => async (params: TActionParameters) => await dispatchMethod(params)(dispatch),
		[dispatch]
	);
}

// Export results.
export {
	UseActionResult,
}

export default useAction;